import "./site.scss";

import { SiteBase } from "@Base/Site/SiteBase";
import { Header } from "./Header";
import { Footer } from "./Footer";

export class BasePage extends SiteBase
{
	public Header: Header;
	public Footer: Footer;

	public Initialize(): void
	{
		super.Initialize();
		this.Header = new Header();
		this.Footer = new Footer();
	}
}
